import type { GlobalAdConfig } from 'interfaces/ads/Ad';

export const ADS_ID = '';
export const ADS_NAME = process.env.GAM_NAME || '';
export const ADS_BASE_PATH = `/${ADS_NAME}`;

const adConfig = {
  enabled: true,
  nonPersonalAds: true,
  path: ADS_BASE_PATH,
  placements: [
    {
      lazyLoad: true,
      name: 'Leaderboard',
      path: ADS_BASE_PATH,
    },
    {
      name: 'RightRailFlex',
      path: ADS_BASE_PATH,
    },
    {
      name: 'SimpleInStream',
      path: ADS_BASE_PATH,
    },
    {
      name: 'InStream',
      path: ADS_BASE_PATH,
    },
    {
      name: 'Gallery',
      path: ADS_BASE_PATH,
    },
    {
      name: 'Footer',
      path: ADS_BASE_PATH,
    },
    {
      name: 'Homepage-InStream',
      path: ADS_BASE_PATH,
    },
    {
      name: 'Newsletter-InStream',
      path: ADS_BASE_PATH,
    },
    {
      name: 'RightRailFlex_Articles',
      path: ADS_BASE_PATH,
    },
    {
      name: 'Footer_Tout',
      path: ADS_BASE_PATH,
    },
    {
      name: 'TermArchive-Billboard',
      path: ADS_BASE_PATH,
    },
    {
      name: 'Homepage-SimpleInStream',
      path: ADS_BASE_PATH,
    },
    {
      name: 'InContent',
      path: ADS_BASE_PATH,
    },
  ],
};

export default adConfig as GlobalAdConfig;
